import React from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";

function PercentageInput({
  label,
  value,
  onChange,
  disabled = false,
  fullWidth = false,
}) {
  const handleInputChange = (event) => {
    const newValue = event.target.value;
    if (newValue === "" || /^\d{0,3}(\.\d{0,2})?$/.test(newValue)) {
      onChange(newValue);
    }
  };

  const handleBlur = () => {
    if (value === "") {
      onChange("");
    }
  };

  return (
    <TextField
      label={label}
      value={value}
      onChange={handleInputChange}
      onBlur={handleBlur}
      disabled={disabled}
      InputProps={{
        endAdornment: <InputAdornment position="end">%</InputAdornment>,
      }}
      fullWidth={fullWidth}
    />
  );
}

export default PercentageInput;
